//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { ICuralateStore } from '@models/AppState';

export const getBulkActionsSelectedItems = (state: ICuralateStore) =>
  state.bulkActions.selectedItems;
